export default [
  {
    name: '経済学',
    description:
      '経済学は、その多様なアプローチや潮流を含め、高校時代にオリンピックに参加したときから発展してきた私の情熱です。国家がどのように管理されるかについての好奇心が、私の政治テストプラットフォーム「Soulgraphy」を作成するインスピレーションとなりました。',
    image: 'kanada',
  },
  {
    name: '自然と動物の世界',
    description:
      '幼い頃から、動物の世界と彼らが住む環境に魅了されてきました。子供の頃は動物学者になりたいと思っていました。',
    image: 'seal',
  },
  {
    name: '世界の国々',
    description:
      '年を追うごとに、世界のさまざまな地域についての知識を深めることにますます魅了されています。言語が時間とともにどのように形成されてきたかを知ることは、さまざまな国の人々の文化や考え方をよりよく理解するのに役立ちます。彼らの歴史を深く掘り下げることで、彼らの現在がどのようになっているかに何が影響しているかが見えやすくなります。私は特に北欧諸国と日本に興味を持っています。',
    image: 'japan',
  },
  {
    name: '電子技術',
    description:
      '電子工学、プログラミング、通信技術は、私にとって単なる興味深い科学の分野ではありません。何よりも、自分自身が発明家のように感じ、独自の電子回路やWebアプリケーションを独立して作成できるツールです。',
    image: 'telecommunications',
  },
  {
    name: '物理学とテクノロジー',
    description:
      '私はいつも世界がどのように機能しているのかに興味がありました。電球の電流であれ、なぜ太陽が輝くのかであれ関係ありません。私にとって物理学とは、世界を知り、なぜ世界がそのように振る舞うのかを理解するプロセスです。この知識を活用することで、安価でクリーンなエネルギーから、効率的なバッテリー、そして命を救う薬まで、私たちの目の前で世界を変える革新的なソリューションを生み出すツールを優れた頭脳に与えることができます。',
    image: 'physics',
  },
  {
    name: '料理',
    description:
      '料理やキッチンでの実験が大好きで、パスタや肉の調理は私の毎日の日課です。ポーランド料理に加えて、韓国料理やインド料理も大好きです。',
    image: 'cooking',
  },
  {
    name: 'ファンタジー、ゲーム、リラクゼーション',
    description:
      '誰も正気の沙汰で仕事から別の仕事へ帰ることはありません。誰もがリラックスして日常生活から離れる時間を必要としているからです。その時間には、普段は映画を見たり、ファンタジーを探求（および執筆）したり、車でドライブに出かけたり、友達とあらゆる種類のゲームをプレイしたりしています。',
    image: 'relax',
  },
]
